import { html, property } from 'lit-element';
import { ifNotNull } from '../../utils/directives';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './breadcrumb-item.lit.scss';

/**
 * @component {kat-breadcrumb-item} KatalBreadcrumbItem Breadcrumbs is a graphical control element used as a navigational aid in user interfaces. It allows users to keep track of their locations within websites.
 * @guideline Do Use "kat-breadcrumb-item" children.
 * @example SetViaHtml {"content": "<kat-breadcrumb-item label=\"Parent\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Group\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Category\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Current Category\" href=\"#\"></kat-breadcrumb-item>"}
 * @status Production
 * @theme flo
 * @a11y {keyboard}
 * @a11y {sr}
 * @a11y {contrast}
 */
@register('kat-breadcrumb-item')
export class KatBreadcrumbItem extends KatLitElement {
  /** The label of your breadcrumb item */
  @property()
  label?: string;

  /** The link where the breadcrumb item leads */
  @property()
  href?: string;

  /** Render the breadcrumb item as a katal icon */
  @property({ attribute: 'icon-name' })
  iconName?: string;

  /** Aria role filling in for semantic HTML */
  @property()
  role = 'listitem'; // Typically we prefix native attributes with kat, but not here because we want to apply the native attribute to the root element.

  static get styles() {
    return [baseStyles, styles];
  }

  render() {
    return html`
      <div class="item">
        ${!this.iconName
          ? html`
              <span part="breadcrumb-item-label" class="label" last>
                ${ifNotNull(this.label)}
              </span>
              <kat-link
                class="link"
                part="breadcrumb-item-link"
                href="${ifNotNull(this.href)}"
                label="${ifNotNull(this.label)}"
              ></kat-link>
            `
          : html`
              <kat-icon
                class="icon"
                part="breadcrumb-item-icon-label"
                name="${this.iconName}"
                size="tiny"
              ></kat-icon>
              <kat-link
                class="link"
                part="breadcrumb-item-link"
                href="${ifNotNull(this.href)}"
              >
                <kat-icon
                  part="breadcrumb-item-display-icon"
                  name="${this.iconName}"
                  size="tiny"
                ></kat-icon>
              </kat-link>
            `}
        <kat-icon
          class="separator"
          part="breadcrumb-item-icon"
          name="chevron-right"
          size="tiny"
        ></kat-icon>
      </div>
    `;
  }
}
